import { useGameContainer } from 'containers/GameContainer';
import { createGameStructuredData } from 'helpers/structuredData';

export default function GameStructuredData() {
  const [{ game }] = useGameContainer();

  const jsonLd = createGameStructuredData(game, game.gameTeams[1].team, game.gameTeams[0].team);

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />;
}
